import React from "react";
import { useSelector } from "react-redux";
import TextoYTitulo from "@components/TextoYTitulo/TextoYTitulo";
import Routes from "app/@Routes/Routes";
import Meta from "@components/Meta/Meta";
import Breadcrumbs from "@components/Breadcrumbs/Breadcrumbs";

const root = process.env.REACT_APP_CMS_STATIC;

function Serviahorro(props) {
  const { serviahorro } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito.AhorroYCredito
  );  
  const defRoute = Routes()?.filter(
    (route) => route?.name === "Serviahorro"
  );

  const itemsBreadcrumb = [
    {
      url: "/",
      text: "Ahorro y Crédito",
    },
    {
      url: "/",
      text: "Ahorros",
    },
  ];  

  return (
    <>
      <Meta
        title={defRoute[0]?.title + " | Plan de Ahorro | CS Ahorro y Crédito Costa Rica"}
        description={defRoute[0]?.description}
        canonicalUrl={defRoute[0]?.url}
      />
      <Breadcrumbs items={itemsBreadcrumb} active={defRoute[0]?.h1} />
      {serviahorro && <>
        <TextoYTitulo            
            title={serviahorro.data.serviahorro[0].titulo}
            text={serviahorro.data.serviahorro[0].descripcion.html}
            borderTopColor="#D7DE00"
        />
        <div className="d-flex justify-content-start ps-5 pb-4">
          <a href={serviahorro?.data?.serviahorro[0]?.botonEnlaceUrl?.url} target="_blank" rel="noreferrer">
            <img src={root+serviahorro?.data?.serviahorro[0]?.botonEnlaceImagen?.urls[0]} alt={serviahorro?.data?.serviahorro[0]?.titulo}/>
          </a>
        </div>
        </>
      }
    </>
  );
}

export default Serviahorro;
